/**
 * main.ts
 *
 * Application entry point - initializes Vue, plugins and mounts the app
 */

// Libraries and plugins
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import {FormValidationService} from '@es-bill/es-bill-common-components';


// Application plugins
import { registerPlugins } from '@/plugins/vuetifyConfig';
import configProvider from '@/plugins/configProvider';
import i18n from "@/plugins/i18n";

// Create Pinia store with persistence
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Initialize app and plugins
const app = createApp(App);
app.use(pinia);
app.use(configProvider);
app.use(i18n);

const formValidationService = new FormValidationService(i18n.global.t);
// Attach the form validation service to the global properties
app.config.globalProperties.$formValidation = formValidationService;
app.provide('$formValidation', formValidationService);

// Register other plugins
registerPlugins(app);

// Router must be imported after store (pinia)
import router from './router';
app.use(router);

// Mount app to DOM
app.mount('#app');
